import { SnfHttpRemoteCall } from './snf-api.http-remote-call';

export class SnfIntlHttpRemoteCall extends SnfHttpRemoteCall {
  language;

  constructor(language, responseParser) {
    super(responseParser);

    this.language = language;
  }

  /**
   * @inheritdoc
   */
  getQuery() {
    return { language: this.language };
  }
}
